var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNationalityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 27.429,
    viewBox: "0 0 24 27.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "flag-regular",
    d: "M2.571,1.286A1.286,1.286,0,0,0,0,1.286V26.143a1.286,1.286,0,1,0,2.571,0V20.786l4.3-1.077a9.527,9.527,0,0,1,6.563.718,9.488,9.488,0,0,0,7.591.4l1.859-.7A1.716,1.716,0,0,0,24,18.52V3.541a1.659,1.659,0,0,0-2.4-1.484l-.514.257a8.794,8.794,0,0,1-7.88,0,8.813,8.813,0,0,0-6.08-.67L2.571,2.786Zm0,4.152,5.175-1.3a6.272,6.272,0,0,1,4.307.471,11.39,11.39,0,0,0,9.375.364V17.93l-1.307.487a6.95,6.95,0,0,1-5.539-.289,12.1,12.1,0,0,0-8.336-.916l-3.675.921Z",
    fill: "#c9c9c9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationalityIcon);
export default __webpack_public_path__ + "static/media/nationality-icon.1b05b27a1e22de3730096bb20392e21b.svg";
export { ForwardRef as ReactComponent };